import { alpha } from '@mui/material';
const useActivityFrameStyles = (is1280to1900, isSmallScreen) => {
    return {
        activityFrame: {
            padding: (theme) => theme.spacing(2),
            backgroundColor: (theme) => theme.palette.common.white,
            borderRadius: 3,
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: (theme) => theme.spacing(1)
        },
        boxTop: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%',
            gap: (theme) => theme.spacing(1.5)
        },
        boxBottom: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            flexWrap: 'wrap',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: (theme) => theme.spacing(1.5)
        }
    };
};
export default useActivityFrameStyles;
